import { defineComponent as u, useAttrs as l, computed as o, openBlock as e, createElementBlock as n, mergeProps as c, unref as r, createBlock as d, createCommentVNode as f, createElementVNode as S, toDisplayString as g } from "vue";
import "./novoui-vuejs80.js";
/* empty css               */
import "./novoui-vuejs89.js";
/* empty css               */
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs8.js";
import "./novoui-vuejs11.js";
import v from "./novoui-vuejs12.js";
import "./novoui-vuejs48.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs17.js";
import "./novoui-vuejs18.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs24.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs34.js";
import "./novoui-vuejs35.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs37.js";
import "./novoui-vuejs38.js";
import "./novoui-vuejs42.js";
/* empty css                */
import "./novoui-vuejs45.js";
import "./novoui-vuejs47.js";
import { NovoStatusTagVariant as T, NovoStatusTagSize as N, NovoStatusTagEmphasis as _, NovoStatusTagState as z, getStatusTagStyleClasses as b, getStatusTagIconSize as h } from "./novoui-vuejs56.js";
const lt = /* @__PURE__ */ u({
  __name: "NStatusTag",
  props: {
    variant: { default: T.squared },
    size: { default: N.default },
    emphasis: { default: _.default },
    state: { default: z.success },
    label: { default: void 0 },
    icon: { default: void 0 }
  },
  setup(i) {
    const { class: a, ...s } = l(), t = i, m = o(() => b(t)), p = o(() => h(t.size));
    return (k, y) => (e(), n("span", c({
      class: [m.value, r(a)]
    }, s), [
      t.icon ? (e(), d(r(v), {
        key: 0,
        icon: t.icon,
        size: p.value
      }, null, 8, ["icon", "size"])) : f("", !0),
      S("span", null, g(t.label), 1)
    ], 16));
  }
});
export {
  lt as default
};
